import {FeatureGate, ProjectFeatureFlag} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';

export function hasAccessToExperimentsApp(currentProject?: CurrentProject): boolean {
  if (!currentProject) {
    return false;
  }

  // Check if it's enabled via a feature flag, or by the feature gate if customer purchased it
  return (
    currentProject.getFeatureGate(FeatureGate.ExperimentsApp) ||
    currentProject.hasFeatureFlag(ProjectFeatureFlag.ExperimentsApp)
  );
}

export function maxExperiments(currentProject?: CurrentProject): number {
  if (!currentProject) {
    return 0;
  }

  // If feature flag is enabled, no limit
  if (currentProject.hasFeatureFlag(ProjectFeatureFlag.ExperimentsApp)) {
    return -1;
  }

  // Otherwise, return the limit from the feature gate
  return currentProject.getFeatureGate(FeatureGate.MaxExperiments) ?? -1;
}
